import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

import type { CampaignMetrics } from "../types";

async function getFlowMetrics(
  workspaceId: string,
  campaignId: string,
  flowId: string,
): Promise<CampaignMetrics> {
  return (
    await get(
      `workspaces/${workspaceId}/campaigns/${campaignId}/flows/${flowId}`,
    )
  ).flow.metrics;
}

export default function useFlowMetrics(campaignId: string, flowId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { campaignsKeys } = getQueryKeys(workspaceId);

  const { data: flowMetrics, isLoading: isLoadingFlowMetrics } = useQuery({
    queryKey: campaignsKeys.flowMetrics(campaignId, flowId),
    queryFn: () => getFlowMetrics(workspaceId, campaignId, flowId),
  });

  return { flowMetrics, isLoadingFlowMetrics };
}
